import React, { useContext, useEffect } from "react";
import Navigation from "./Components/Navigation/Navigation";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { ThemeContext } from "./Context/Theme";
import { AuthContext } from "./Context/Auth";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import { RouteContext } from "./Context/RouteContext";

const App = () => {
  const { dark } = useContext(ThemeContext);

  const { inMemRoute } = useContext(RouteContext);
  const history = useHistory();

  const { login } = useContext(AuthContext);

  useEffect(() => {
    Auth.currentSession().then((data) => {
      if (data) {
        let idToken = data.getIdToken().getJwtToken();
        login(idToken);
        history.push(inMemRoute);
      }
    });
  }, []);

  const theme = createMuiTheme({
    palette: {
      type: dark ? "dark" : "light",
      primary: {
        main: dark ? "#c0cdd8" : "#445B6E",
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 700,
        md: 1250,
        lg: 1500,
        xl: 1920,
      },
    },
  });

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Navigation />
      </ThemeProvider>
    </div>
  );
};

export default App;
